module.exports = __webpack_public_path__ + "images/6ff7718730258aa466345edeeedcbdb1-trendingImg7.png";